import { createServerFn } from "@tanstack/solid-start";
import { z } from "zod";
import { withSentrySpan } from "~/lib/sentry-span";
import { authFunctionMiddleware } from "~/server/middleware/auth";

export const GetBankAccountsPageDataInputSchema = z.object({
  businessId: z.string().trim().min(1),
});

/**
 * Aggregate server function for the bank accounts index page.
 *
 * Fetches bank accounts list and business detail in a single HTTP round trip
 * on client-side navigation.
 */
export const getBankAccountsPageData = createServerFn({ method: "GET" })
  .middleware([authFunctionMiddleware])
  .validator((i: unknown) => GetBankAccountsPageDataInputSchema.parse(i))
  .handler(async ({ context, data }) => {
    return withSentrySpan("bankAccounts.pageData", async () => {
      const [businessMod, bankAccountMod] = await Promise.all([
        import("../business/business.server"),
        import("./bank-account.server"),
      ]);
      const { getBusinessDetailForUser } = businessMod;
      const { listBankAccountsForUser } = bankAccountMod;

      const [businessDetail, bankAccounts] = await Promise.all([
        getBusinessDetailForUser(context.user.id, data.businessId),
        listBankAccountsForUser(context.user.id, data.businessId, {
          limit: 20,
        }),
      ]);

      return { businessDetail, bankAccounts } as const;
    });
  });
